import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { ContactColumn, ProfileInfoCard, ViewButton } from "@components";

import { ROUTES } from "@constants/routes";

import { EmployeeType } from "@type/HRM/employees";
import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";

const {
  CREATE,
  HRM: { TERMINATION },
} = ROUTES;

export const TableColumn = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 0,
      key: "nameBn",
      name: t("TERMINATION_LIST.TABLE.COLUMN.NAME"),
      render: (__: string, row: EmployeeType) => (
        <ProfileInfoCard employee={row as any} />
      ),
    },
    {
      id: 1,
      key: "employeeCode",
      name: t("TERMINATION_LIST.TABLE.COLUMN.EMPLOYEE_ID"),
      render: (employeeCode: string) => (
        <Text color="info">{employeeCode}</Text>
      ),
    },
    {
      id: 3,
      key: "joiningDate",
      name: t("TERMINATION_LIST.TABLE.COLUMN.TERMINATION_DATE"),
      render: (dateOfDeath: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {dateOfDeath}
        </Text>
      ),
    },
    {
      id: 5,
      key: "email",
      name: t("TERMINATION_LIST.TABLE.COLUMN.CONTACTS"),
      render: (_: string, row: EmployeeCommonInfoType) => (
        <ContactColumn employee={row} />
      ),
    },
    {
      id: 6,
      key: "id",
      name: "",
      render: (_: number | string, row: any) => (
        <ViewButton
          link={`${TERMINATION}/${row.id}/${CREATE}`}
          label="TERMINATION_LIST.TABLE.COLUMN.BUTTON_TEXT"
        />
      ),
    },
  ];
};
